import { ref, computed, watch } from 'vue'
import { useStore } from 'vuex'
import { TransportationTypes } from '@/utils/transportTypes'

export default function tankMixin () {
  const store = useStore()

  const transportType = ref<string | null>(localStorage.getItem('shippingMethod'))

  const items = computed(() => store.state.basket.items)

  watch(items, () => {
    transportType.value = localStorage.getItem('shippingMethod')
  }, { immediate: true })

  const isTankBeerOrder = computed(() => {
    return transportType.value === TransportationTypes.TANK
  })

  return isTankBeerOrder
}
